(() => {
  const SHOW_DELAY = 1500;
  const banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;

  const key = banner.dataset.storageKey || 'lb-cookies-accepted';

  const hasChosen = () => {
    try {
      return localStorage.getItem(key) !== null;
    } catch (e) {
      return false;
    }
  };

  const setChoice = (value) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* storage disabled */
    }
  };

  // The Customer Privacy API is not on the page by default — it has to be
  // requested via loadFeatures. Without this, window.Shopify.customerPrivacy is
  // undefined, setTrackingConsent is never reachable, and Shopify never learns
  // what the visitor chose. Pixels that declare privacy purposes then stay
  // switched off permanently.
  const withPrivacyApi = (callback) => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      callback();
      return;
    }
    if (!window.Shopify?.loadFeatures) return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error) return;
        if (window.Shopify?.customerPrivacy?.setTrackingConsent) callback();
      }
    );
  };

  const updateShopifyConsent = (accepted) => {
    withPrivacyApi(() => {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: accepted,
            marketing: accepted,
            preferences: accepted,
            sale_of_data: accepted,
          },
          () => {
            /* consent saved */
          }
        );
      } catch (e) {
        /* consent could not be recorded */
      }
    });
  };

  // Warm the API on load so a click records consent immediately rather than
  // waiting on a network round trip.
  withPrivacyApi(() => {});

  const show = () => {
    banner.classList.remove('hidden');
    requestAnimationFrame(() => {
      banner.classList.remove('opacity-0', 'translate-y-2');
      banner.classList.add('opacity-100', 'translate-y-0');
    });
  };

  const hide = () => {
    banner.classList.add('opacity-0', 'translate-y-2');
    banner.classList.remove('opacity-100', 'translate-y-0');
    setTimeout(() => {
      banner.classList.add('hidden');
    }, 500);
  };

  if (!hasChosen()) {
    setTimeout(show, SHOW_DELAY);
  }

  banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => {
    setChoice('accepted');
    updateShopifyConsent(true);
    hide();
  });

  banner.querySelector('[data-cookie-decline]')?.addEventListener('click', () => {
    setChoice('declined');
    updateShopifyConsent(false);
    hide();
  });

  banner.querySelector('[data-cookie-close]')?.addEventListener('click', () => {
    // Treat close as a dismissal without explicit consent — re-prompt next session
    hide();
  });
})();
